import { lockScroll, matchMedia } from './utility';

const { lock, unlock } = lockScroll();

class HamburgerMenu {
  constructor(triggerButton, menu, banner) {
    this.triggerButton = triggerButton;
    this.menu = menu;
    this.isExpanded = false;
    this.banner = banner;
    this.anchorLinks = document.querySelectorAll('a[href^="#"]');
    this.anchorLinksArr = Array.prototype.slice.call(this.anchorLinks);
  }

  init() {
    this.triggerButton.addEventListener('click', () => this.handleClickTrigger());
    matchMedia('lg').addEventListener('change', () => this.handleChangeMedia());
    this.handleChangeMedia();
    this.handleClickLinks();
  }

  showMenu() {
    this.isExpanded = true;
    this.triggerButton.setAttribute('aria-expanded', this.isExpanded);
    this.triggerButton.setAttribute('aria-label', 'メニューを非表示にする');
    this.menu.setAttribute('aria-hidden', !this.isExpanded);
    if (this.banner) {
      this.banner.classList.add('_showMenu');
    }
  }

  hideMenu() {
    this.isExpanded = false;
    this.triggerButton.setAttribute('aria-expanded', this.isExpanded);
    this.triggerButton.setAttribute('aria-label', 'メニューを表示する');
    this.menu.setAttribute('aria-hidden', !this.isExpanded);
    if (this.banner) {
      this.banner.classList.remove('_showMenu');
    }
  }

  handleClickTrigger() {
    if (this.isExpanded) {
      this.hideMenu();
      unlock();
    } else {
      this.showMenu();
      lock();
    }
  }

  handleChangeMedia() {
    const isMobile = !matchMedia('lg').matches;
    unlock();
    if (isMobile) {
      this.hideMenu();
    } else {
      this.showMenu();
    }
  }

  handleClickLinks() {
    this.anchorLinksArr.forEach((link) => {
      link.addEventListener('click', () => {
        this.hideMenu();
        unlock();
      });
    });
  }
}

export const hamburgerMenu = () => {
  const triggerButton = document.getElementById('js-hamburger');
  const menu = document.getElementById('js-hamburger-menu');
  const banner = document.getElementById('js-showBanner');
  if (!triggerButton || !menu) return;
  const hamburgerInstance = new HamburgerMenu(triggerButton, menu, banner);
  hamburgerInstance.init();
};
